import { useRef } from 'react';
export function useDeepCompareMemoize(value) {
    const ref = useRef(value);
    const prev = useRef(JSON.stringify(value));
    const current = JSON.stringify(value);
    if (prev.current !== current) {
        ref.current = value;
        prev.current = current;
    }
    return ref.current;
}
